import React, { startTransition, useDeferredValue, useEffect, useRef, useState } from "react";
import { FiGrid, FiHome, FiShoppingCart } from "react-icons/fi";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";

import { useCart } from "../cart";
import {
  STORE_CART_PATH,
  STORE_CATALOG_PATH,
  STORE_HOME_PATH,
} from "../../routes";
import "../storefront.css";


export default function StoreLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { totalItems } = useCart();

  /* Mahsulot qidiruv (catalog ga yo'naltiradi) */
  const [search, setSearch] = useState("");
  const deferredSearch = useDeferredValue(search);
  const latestLocationRef = useRef(location);
  const searchEditOriginPathRef = useRef("");

  /* Do'kon qidiruvi (faqat bosh sahifada ishlatiladi) */
  const [shopSearch, setShopSearch] = useState("");

  const isHomePage = location.pathname === STORE_HOME_PATH;
  const isCatalogFlow =
    location.pathname.startsWith(STORE_CATALOG_PATH) || location.pathname.startsWith("/products/");
  const isCartPage = location.pathname.startsWith(STORE_CART_PATH);

  useEffect(() => {
    latestLocationRef.current = location;
  }, [location]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    searchEditOriginPathRef.current = "";
    setSearch(params.get("search") || "");
    if (!isHomePage) setShopSearch("");
  }, [location.pathname, location.search]);

  useEffect(() => {
    const originPath = searchEditOriginPathRef.current;
    if (!originPath) return;

    const currentLocation = latestLocationRef.current;
    const isCatalogPage = currentLocation.pathname.startsWith(STORE_CATALOG_PATH);
    const currentParams = new URLSearchParams(currentLocation.search);
    const currentSearch = currentParams.get("search") || "";
    const normalizedSearch = deferredSearch.trim();

    if (currentLocation.pathname !== originPath && !isCatalogPage) {
      searchEditOriginPathRef.current = "";
      return;
    }
    if (!isCatalogPage && !normalizedSearch) {
      searchEditOriginPathRef.current = "";
      return;
    }
    if (normalizedSearch === currentSearch) {
      searchEditOriginPathRef.current = "";
      return;
    }

    const params = isCatalogPage ? new URLSearchParams(currentLocation.search) : new URLSearchParams();
    if (normalizedSearch) params.set("search", normalizedSearch);
    else params.delete("search");
    searchEditOriginPathRef.current = "";

    startTransition(() => {
      navigate(`${STORE_CATALOG_PATH}${params.toString() ? `?${params.toString()}` : ""}`, {
        replace: isCatalogPage,
      });
    });
  }, [deferredSearch, navigate]);

  const handleSearchChange = (event) => {
    searchEditOriginPathRef.current = latestLocationRef.current.pathname;
    setSearch(event.target.value);
  };

  return (
    <div className="storefront">
      <div className="storefront-glow storefront-glow-left" />
      <div className="storefront-glow storefront-glow-right" />

      <header className="store-header">
        <div className="store-header-inner store-header-compact">
          <nav className="store-nav">
            <NavLink end to={STORE_HOME_PATH}>Bozor</NavLink>
            <NavLink to={STORE_CATALOG_PATH}>Catalog</NavLink>
          </nav>

          {/* Bosh sahifada 2 ta input, boshqa sahifalarda 1 ta */}
          <div className="store-search-form">
            {isHomePage && (
              <input
                className="store-search-input store-search-shop-input"
                onChange={(e) => setShopSearch(e.target.value)}
                placeholder="Do'konlarni qidirish..."
                type="search"
                value={shopSearch}
              />
            )}
            <input
              className="store-search-input"
              onChange={handleSearchChange}
              placeholder="Mahsulot qidirish..."
              type="search"
              value={search}
            />
          </div>

          <NavLink className="store-cart-link" to={STORE_CART_PATH}>
            Savat
            {totalItems ? <span>{totalItems}</span> : null}
          </NavLink>
        </div>
      </header>

      {/* shopSearch ni StoreHomePage ga Outlet context orqali uzatamiz */}
      <Outlet context={{ shopSearch, setShopSearch }} />

      <nav className="store-mobile-dock" aria-label="Mobil navigatsiya">
        <NavLink
          aria-label="Bosh sahifa"
          className={`store-mobile-dock-link${isHomePage ? " active" : ""}`}
          end title="Bosh sahifa"
          to={STORE_HOME_PATH}
        >
          <FiHome aria-hidden="true" />
        </NavLink>
        <NavLink
          aria-label="Catalog"
          className={`store-mobile-dock-link${isCatalogFlow ? " active" : ""}`}
          title="Catalog"
          to={STORE_CATALOG_PATH}
        >
          <FiGrid aria-hidden="true" />
        </NavLink>
        <NavLink
          aria-label="Savat"
          className={`store-mobile-dock-link${isCartPage ? " active" : ""}`}
          title="Savat"
          to={STORE_CART_PATH}
        >
          <FiShoppingCart aria-hidden="true" />
          {totalItems ? <span className="store-mobile-dock-badge">{totalItems}</span> : null}
        </NavLink>
      </nav>
    </div>
  );
}
